const zipForm = () => {
  // Redirect user to find-new-internet with their zip code and kbid in the URL (edit kbid in filters)
  window.clwpForm.addAction('redirect-to-isp', formData => new Promise(resolve => {

    // Begin creating URL with existing URL params included
    const destinationURL = new URLSearchParams(location.search);

    destinationURL.append('zip', formData.get('zip'));
    destinationURL.append('kbid', formData.get('kbid'));

    window.location = `${window.SITE.siteURL}/find-new-internet?${destinationURL.toString()}`;

    resolve({
      success: true,
      data: {
        message: 'Finished! Redirecting...',
      },
    });

  }));

};
export default zipForm;
